module.exports = __webpack_public_path__ + "static/media/orion-image.fb62dc5f.jpg";